/*
 * File: Router.js
 * Project: mp-mobile-app
 *
 * Created by Jed Dumire on 12/31/2019
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Custom Route wrapper for passing props down to the Route
 */
import React from "react";
import { Route, Switch } from "react-router-dom";
import { isMobile } from "react-device-detect";
import AppStore from "Store";
import PubSub from "pubsub-js";
import NotFound from "components/NotFound";
import { PropTypes } from "prop-types";
import { LastPageStore } from "utils/LastPageStore";
import { useStore } from "utils/useStore";

// subscribe to the event to remove last page on logout
PubSub.subscribe("LOGGING_OUT", () => {
  LastPageStore.removeLastPage();
});

const Router = ({ routes: propRoutes, ...props }) => {
  const appStore = useStore(AppStore);
  // store the last page so we can use it for standalone apps
  LastPageStore.setLastPage(window.location.pathname.substr(1));
  const routes = propRoutes.map((route, idx) => {
    return (
      <Route
        key={idx}
        render={routeProps => (
          <route.component
            isMobile={isMobile}
            path={route.path}
            appStore={appStore}
            {...props}
            {...routeProps}
          />
        )}
        path={route.path}
        exact={route.exact}
      />
    );
  });

  routes.push(
    <Route key="fallbackRoute" path="*" render={() => <NotFound />} />
  );
  return <Switch>{routes}</Switch>;
};

Router.propTypes = {
  routes: PropTypes.array.isRequired
};

export default Router;
